import React, { FC } from 'react';

import { formatOption }           from '@src/util';
import { PreSelectedSelectField } from '@src/types';
import { SelectField }            from '../../../components/forms';

const Dropdown: FC<PreSelectedSelectField> = ( { useStringValues = true, ...props } ) => {

	let options = [
		formatOption( useStringValues ? 'true' : true, 'True' ),
		formatOption( useStringValues ? 'false' : false, 'False' ),
	];

	return (
		<SelectField
			{ ...props }
			options={ options }>
		</SelectField>
	);
};

export { Dropdown as BooleanDropdown };
